import IbanLogo from 'src/assets/logos/iban-circle.svg';
import LydiaLogo from 'src/assets/logos/lydia-circle.svg';
import PaypalLogo from 'src/assets/logos/paypal-circle.svg';
import WeroLogo from 'src/assets/logos/wero-circle.svg';

export const paymentMethodsConfig = {
  IBAN: {
    label: 'IBAN',
    logo: IbanLogo,
  },
  LYDIA: {
    label: 'Lydia',
    logo: LydiaLogo,
  },
  PAYPAL: {
    label: 'Paypal',
    logo: PaypalLogo,
  },
  WERO: {
    label: 'Wero',
    logo: WeroLogo,
  },
};
